module.exports = __webpack_public_path__ + "img/menu2_hover.3f16c08b.png";